import { useEffect, useState } from "react";
import { getCollectedSync, } from "../api/gallery/collectedSync";
import { getGalleryPlanLimits, } from "../api/gallery/galleryPlan";
/**
 * The user's Collected Players Sync, read per user and again when `version` changes; cleared signed out. Kept while it
 * refetches, so the counts don't blink. `setCollectedSync` is for a host that polls a running sync.
 */
export const useCollectedSync = (userUuid, version) => {
    const [collectedSync, setCollectedSync] = useState();
    useEffect(() => {
        if (!userUuid) {
            setCollectedSync(undefined);
            return;
        }
        let cancelled = false;
        getCollectedSync()
            .then((result) => {
            if (!cancelled)
                setCollectedSync(result);
        })
            .catch(() => undefined);
        return () => {
            cancelled = true;
        };
    }, [userUuid, version]);
    return { collectedSync, setCollectedSync };
};
/**
 * The planners' limit placeholders (coins from the latest Club Import), per user and again when `version` changes;
 * cleared signed out, kept while it refetches.
 */
export const useGalleryPlanLimits = (userUuid, version) => {
    const [limits, setLimits] = useState({});
    useEffect(() => {
        if (!userUuid) {
            setLimits({});
            return;
        }
        let cancelled = false;
        getGalleryPlanLimits()
            .then((result) => {
            if (!cancelled)
                setLimits(result);
        })
            .catch(() => undefined);
        return () => {
            cancelled = true;
        };
    }, [userUuid, version]);
    return limits;
};
//# sourceMappingURL=useGalleryAccountData.js.map